import { render, staticRenderFns } from "./RoundtableList-v2.vue?vue&type=template&id=4819f99c"
import script from "./RoundtableList-v2.vue?vue&type=script&lang=js"
export * from "./RoundtableList-v2.vue?vue&type=script&lang=js"
import style0 from "./RoundtableList-v2.vue?vue&type=style&index=0&id=4819f99c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports